import { useEffect, useRef } from "react";
import "./SidebarAds.css";

const HorizontalAds = () => {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (
        adRef.current &&
        !adRef.current.getAttribute("data-adsbygoogle-status")
      ) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error("AdSense Error:", err);
    }
  }, []);

  return (
    <div className="horizontal-ad-container">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="9748200331"
        data-ad-format="autorelaxed"
      ></ins>
    </div>
  );
};

export default HorizontalAds;